import { useMemo } from "react";
import { useJobSocketRefetch } from "../jobs/jobs-list/hooks/useJobSocketRefetch";
import { useAllJobEventsQuery } from "./jobs-calendar/hooks/useAllJobEventsQuery";
const normalizeJobType = (item: any) => {
  const rawClientType = item?.client?.type?.toLowerCase() || item?.job?.client?.type?.toLowerCase() || "";

  if (rawClientType.includes("comercial") || rawClientType.includes("commercial")) {
    return "commercial";
  }

  return "residential";
};

const mapJobEventToWidgetJob = (item: any) => {
  const job = item?.job;
  if (!job) return null;

  return {
    ...job,

    id: String(item.uid),
    jobId: String(job.id),
    serviceOrderId: String(job.id),
    eventUid: item.uid,

    status: item.status || job.status,
    title: job.alias || `Job #${job.id}`,
    type: normalizeJobType(item),
    jobTypeLabel: job.type === "basic" ? "Basic" : "Advanced",

    date: item.startDate,
    startDate: item.startDate,
    endDate: item.endDate,

    progress: item.status === "completed" || job.status === "completed" ? 100 : (job.progress ?? 0),

    client: item.client || job.client,
    company: item.company || job.company,
    coverageArea: item.coverageArea || job.coverageArea,
    workforce: item.workforce || [],

    event: {
      uid: item.uid,
      startDate: item.startDate,
      endDate: item.endDate,
      mode: job?.quote?.event?.mode || "SINGLE_EXECUTION",
      typeName: job?.quote?.event?.typeName || "child-event",
      frequency: job?.quote?.event?.frequency || null,
    },
  };
};

export const useJobEventsData = (startDate?: string, endDate?: string) => {
  const query = useAllJobEventsQuery({ startDate, endDate, enabled: true });

  const jobsReal = useMemo(() => {
    const items = query.data?.data?.items ?? [];

    const mapped = items.map(mapJobEventToWidgetJob).filter(Boolean);

    return mapped;
  }, [query.data]);

  const socketJobItems = useMemo(() => jobsReal.map(job => ({ id: job.jobId })), [jobsReal]);
  useJobSocketRefetch({ jobItems: socketJobItems, refetch: query.refetch });

  return {
    jobsReal,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    refetch: query.refetch,
    error: query.error,
  };
};
